/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { ComponentType, ReactNode, useState } from "react";

type Tab = {
  label: string;
  content: ReactNode;
};

export type RenderTabButtonInfo = {
  index: number;
  label: string;
  isActive: boolean;
  onClick: () => void;
};

type Props = {
  tabs: Tab[];
  defaultIndex?: number;
  renderTabButton: (args: RenderTabButtonInfo) => ReactNode;

  TabListWrapper?: ComponentType<{ children: ReactNode }>;
};

export const TabController = ({
  tabs,
  defaultIndex = 0,
  renderTabButton,
  TabListWrapper = ({ children }) => <div>{children}</div>,
}: Props) => {
  const [activeIndex, setActiveIndex] = useState(defaultIndex);

  return (
    <>
      <TabListWrapper>
        {tabs.map((tab, index) =>
          renderTabButton({
            index,
            label: tab.label,
            isActive: index === activeIndex,
            onClick: () => setActiveIndex(index),
          }),
        )}
      </TabListWrapper>
      <div>{tabs[activeIndex]?.content}</div>
    </>
  );
};
